import styled, { css } from 'styled-components';
import { Box, Avatar, ButtonAppearance, Button, ButtonSize } from '@bechtel/gds';

export const PendingApprovalListItemStyled = styled(Box).attrs({
  p: { sm: '500' },
  justifyContent: { sm: 'space-between' },
  flexShrink: { sm: '0' },
})`
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
`;

export const WorklistInfoStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  flexGrow: { sm: '1' },
})`
  & > * {
    margin-bottom: ${({ theme }) => theme.spacings[300]};
  }
`;

export const CrewMemberStyled = styled(Box).attrs({
  alignSelf: { sm: 'center' },
  flexDirection: { sm: 'column' },
  mx: { sm: '500' },
  flexShrink: { sm: '0' },
})`
  & > :not(:last-child) {
    margin-bottom: ${({ theme }) => theme.spacings[450]};
  }
  width: 25%; /*Fixed width is required to allow  commodity tag to take maximum width */
`;

export const AvatarRegularStyled = styled(Avatar)`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[200]};
    margin-right: ${theme.spacings[400]};
  `}
  flex-shrink: 0;
`;

export const ApproveButtonStyled = styled(Button).attrs({
  appearance: ButtonAppearance.TERTIARY,
  size: ButtonSize.SMALL,
})`
  background-color: ${({ theme }) => theme.colors.yellow[300]};
`;

export const RejectButtonStyled = styled(Button).attrs({
  appearance: ButtonAppearance.TERTIARY,
  size: ButtonSize.SMALL,
})`
  border: 1px solid ${({ theme }) => theme.colors.yellow[500]};
`;

export const UnApproveButtonStyled = styled(Button).attrs({
  appearance: ButtonAppearance.TERTIARY,
  size: ButtonSize.SMALL,
})`
  background-color: ${({ theme }) => theme.colors.yellow[300]};
`;
